module.exports = __webpack_public_path__ + "static/media/registrirane_narushenie.87c0af98.pdf";